import React, { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom';
import { CalendarCheck } from 'lucide-react';
import Leaderboard from '../../components/Tables/Leaderboard'
import { apiFetch } from 'api';
import '../Info/Info.sass'

export default function Home() {
    const { leagueId } = useParams();
    const navigate = useNavigate();
    const [nextRound, setNextRound] = useState(null);

    useEffect(() => {
        const today = new Date().toISOString().split('T')[0];
        apiFetch(`/league/${leagueId}/upcoming-rounds`)
            .then(r => r.json())
            .then(data => {
                const next = (data || [])
                    .filter(r => r.date >= today)
                    .sort((a, b) => (a.date || '').localeCompare(b.date || ''))[0] || null;
                setNextRound(next);
            })
            .catch(console.error);
    }, [leagueId]);

    return (
        <div className="page">
            {nextRound && (
                <div className="upcoming-rounds">
                    <div className="section-header">
                        <div className="sub-header sub-header--with-img">
                            <CalendarCheck size="20" />
                            <h2>Nästa runda</h2>
                        </div>
                    </div>
                    <div className="round-list">
                        <div className="round-item" onClick={() => navigate(`/league/${leagueId}/info`)} style={{ cursor: 'pointer', maxWidth: '400px' }}>
                            <div className="round-details">
                                {nextRound.name && <span className="round-name">{nextRound.name}</span>}
                                <span>{nextRound.club} · {nextRound.course}{nextRound.tee && nextRound.tee !== 'Ej bestämt' ? ` · ${nextRound.tee}` : ''}</span>
                                <span className="round-date">
                                    {nextRound.date}{nextRound.firstTeeTime ? ` · ${nextRound.firstTeeTime}` : ''}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <Leaderboard />
        </div>
    );
}
